import { render, staticRenderFns } from "./educator.vue?vue&type=template&id=79d114f8"
import script from "./educator.vue?vue&type=script&lang=js"
export * from "./educator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports